<div class="methodForm">
  <p [innerHTML]="('cashRobotText1' | translation | async)"></p>
  <app-counter-item [number]="1">
    Sino tienes una cuenta de Payvalida, regístrate y obtén una cuenta haciendo clic aquí: <a
    [href]="environmentService.isProd() ? 'https://app-prod.payvalida.com/' : 'https://app-sandbox.payvalida.com/'"
    target="_blank" rel="noopener noreferrer">{{ environmentService.isProd() ? 'https://app-prod.payvalida.com/' : 'https://app-sandbox.payvalida.com/'}}</a> Tranquilo, esto se
    hace una sola vez.
  </app-counter-item>
  <app-counter-item [number]="2">
    Al día siguiente de tu registro, quedas habilitado para recargar tu cuenta de Payvalida y así proceder con tus
    compras:
  </app-counter-item>
  <img src="assets/images/instructivo-banco.webp" style="max-width: 100%">
  <app-counter-item [number]="3">
    Con la recarga que ya tienes en tu cuenta de acuerdo al paso <b>2</b>, ve a tu comercio favorito y en el proceso de
    compra
    elige siempre el logo de Payvalida para pagar. Ingresa con tu usuario y contraseña y tu compra se procesará de forma
    inmediata.
  </app-counter-item>
  <app-counter-item [number]="4">
    Puedes usar el anterior método para comprar <span class="link" (click)="handleChangeMethod()">aquí</span>. Ten en
    cuenta que se procesará hasta en 48 horas.
  </app-counter-item>
  <div class="otherInfo">
    <p innerHTML="{{ 'cashRobotText2' | translation | async }}"></p>
  </div>
</div>
